import React from 'react';

export default function createConnectedField(WrappedField, formActions) {
  class ConnectedField extends React.Component {
    handleChange = value => {
      let newValue = value;
      // If a change mapper was provided, run it to modify the value
      // before setting it in the state.
      if (this.formValueChangeMapper) {
        newValue = this.formValueChangeMapper(newValue);
      }
      formActions.changeField(this.props.name, newValue);
    };

    handleBlur = () => {
      formActions.blurField(this.props.name);
    };

    handleError = error => {
      formActions.setFieldError(this.props.name, error);
    };

    constructor(props) {
      super(props);
      // If a value change mapper is provided, add it to the instance
      // to be used when the value is changed.
      if (props.formValueChangeMapper) {
        this.formValueChangeMapper = props.formValueChangeMapper;
      }
    }

    render() {
      // formStateValueMapper is an optional additional function that maps this.props.value to another form.
      // For example, `formStateValueMapper={userIntegration => userIntegration.externId}` maps a userIntegration value
      // to its .externId so we can render it properly in the AdminUserInputField
      const {formState, formStateValueMapper, ...extraProps} = this.props;

      let value =
        (formState && formState.get(this.props.name)) ||
        (formState && formState.getIn(['values', this.props.name])) ||
        '';

      if (formStateValueMapper !== undefined && formStateValueMapper !== null) {
        value = formStateValueMapper(value);
      }

      return (
        <WrappedField
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onError={this.handleError}
          value={value}
          {...extraProps}
        />
      );
    }
  }

  const wrappedFieldDisplayName = WrappedField.displayName || WrappedField.name || 'Component';
  ConnectedField.displayName = `ConnectedField(${wrappedFieldDisplayName})`;

  return ConnectedField;
}
